import type { SummaryResultsFilter } from '@modules/types/graphql';
import type { SummaryDataFilters } from '@modules/summary-results/hooks';

class SummaryResultsFilterRequest {
    lapIds: SummaryResultsFilter['lapIds'];
    from: SummaryResultsFilter['from'];
    to: SummaryResultsFilter['to'];
    locationId: SummaryResultsFilter['locationId'];
    regionId: SummaryResultsFilter['regionId'];

    constructor(values: SummaryDataFilters) {
        this.lapIds = values.lapIds;
        this.from = values.from;
        this.to = values.to;
        this.locationId = values.locationId;
        this.regionId = values.regionId;
    }
}

export { SummaryResultsFilterRequest };
